import type { QuizBuilderSteps } from '@repo/types/enums/quizBuilderSteps';

import { cn } from '@repo/lib/cn';
import { quizBuilderNavigationSteps } from '@repo/lib/quiz/quizBuilderNavigationSteps';
import { Fragment } from 'react';
import { Link } from 'react-router';

import QuizBuilderHeaderSubmitButtons from '@/components/features/quiz/quiz-builder/QuizBuilderHeaderSubmitButtons';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { useQuizBuilder } from '@/context/quiz-builder';

export default function QuizBuilderHeader() {
  const { handleNavigateStep, currentStep } = useQuizBuilder();

  const onNavigateStep = async (to: QuizBuilderSteps) => {
    await handleNavigateStep(to);
  };

  return (
    <header className="flex flex-col gap-3 border-b p-4 sm:flex-row">
      <Breadcrumb className="flex items-center">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/manage/quizzes">Quizy</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          {quizBuilderNavigationSteps.map((step, index) => (
            <Fragment key={step.to}>
              {
                <BreadcrumbItem>
                  <BreadcrumbLink className={cn(currentStep === step.to && 'text-accent-foreground')} onClick={() => onNavigateStep(step.to)}>
                    {step.label}
                  </BreadcrumbLink>
                </BreadcrumbItem>
              }
              {index !== quizBuilderNavigationSteps.length - 1 && <BreadcrumbSeparator />}
            </Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
      <div className="ml-auto flex items-center gap-2">
        <QuizBuilderHeaderSubmitButtons />
      </div>
    </header>
  );
}
